const MASK_CHAR = '•';
const VISIBLE_DIGITS = 4;

/** `123456789` → `•••••6789` — at most the last four digits stay legible at rest. */
export function maskTaxId(taxId: string): string {
    const visible = taxId.slice(-VISIBLE_DIGITS);
    const hiddenLength = Math.max(taxId.length - VISIBLE_DIGITS, 0);
    return MASK_CHAR.repeat(hiddenLength) + visible;
}
